import baseApi from '../utils/ApiUtils';

/**
 * Dzongkhag servicecs
 * */
export const dzongkhagList = (method, payload = null, params = null) => {
  return baseApi(`/dzongkhags/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const gewogList = (method, id, payload = null, params = null) => {
  return baseApi(`/dzongkhags/${id}/gewogs/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const villageList = (method, id, payload = null, params = null) => {
  return baseApi(`/gewogs/${id}/villages/`, method, params, payload).then(response => {
    return response.data;
  });
};